import { createContext, useContext, useEffect, useState } from "react";
import { fetchGlobalCms } from "../lib/cms";

const CmsCtx = createContext({ data: { header: {}, footer: {}, announcement_banner: {}, contact: {} }, loading: true });

export function CmsProvider({ children }) {
  const [data, setData] = useState({ header: {}, footer: {}, announcement_banner: {}, contact: {} });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGlobalCms()
      .then(setData)
      .finally(() => setLoading(false));
  }, []);

  return <CmsCtx.Provider value={{ data, loading }}>{children}</CmsCtx.Provider>;
}

export const useCms = () => useContext(CmsCtx);
